export const isAppStoreEnabled = ({ featureFlags: ff }) => ff.appStoreEnabled;
